import {BigNumber} from "ethers";
import {ErrorType} from "../lib/mint";

export enum MintingWindowState {
    BEFORE_MINT,
    OG_MINT,
    PUBLIC_MINT,
}

// export type WindowStateOptions = MintingWindowState.BEFORE_MINT | MintingWindowState.OG_MINT | MintingWindowState.WHITELIST_MINT | MintingWindowState.PUBLIC_MINT;

export interface MintWindowParams {
    title: string;
    nextMint: string | null;
    state: MintingWindowState;
    nextMintOpensAt: number | null;
    basePrice: BigNumber;
}


export interface ErrorState {
    type: ErrorType | null,
    message: string | null
}

